import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const LiveCoursePaymentPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Processing your registration...');
    const [isProcessing, setIsProcessing] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('app_token');
        if (token) {
            try {
                const decodedUser = jwtDecode(token);
                setUser(decodedUser);
            } catch (error) {
                console.error("Invalid token:", error);
            }
        }
    }, []);

    useEffect(() => {
        const processRegistration = async () => {
            const token = localStorage.getItem('app_token');
            if (!token) {
                setMessage('Error: You are not logged in.');
                setIsProcessing(false);
                return;
            }

            try {
                // This simulates the payment gateway being successful.
                // In a real app, you would handle payment here and only proceed on success.
                await axios.post(
                    `/api/live-courses/${courseId}/register`,
                    {}, // Empty body
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                // If successful, redirect to the completion page.
                navigate(`/live-courses/registration-complete`);

            } catch (err) {
                 if (err.response?.status === 409) {
                    // 409 Conflict means user is already registered
                    setMessage("You are already registered for this course. Redirecting...");
                    // Only redirect to courses if user is admin
                    if (user && user.role === 'admin') {
                        setTimeout(() => navigate('/courses'), 3000);
                    } else {
                        setTimeout(() => navigate('/'), 3000);
                    }
                } else {
                    setMessage('There was an error with your registration. Please try again.');
                }
                setIsProcessing(false);
            }
        };

        const timer = setTimeout(processRegistration, 2000); // Simulate a 2-second delay
        return () => clearTimeout(timer);
    }, [courseId, navigate]);

    return (
        <div className="registration-complete-page">
            <div className="completion-card">
                 {isProcessing ? (
                    <div className="spinner"></div> /* Simple spinner placeholder */
                 ) : (
                    <span className="completion-icon material-icons">error</span>
                 )}
                <h2 className="completion-title">{message}</h2>
            </div>
            <style>{`.spinner { border: 4px solid rgba(0,0,0,0.1); width: 36px; height: 36px; border-radius: 50%; border-left-color: #16a085; animation: spin 1s ease infinite; } @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

export default LiveCoursePaymentPage;